import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const fmt = (iso) => new Date(iso).toISOString().replace("T", " ").slice(0, 19) + " UTC";

export const SignupsTable = ({ data, onDelete, onLogout, exportUrl }) => {
  const [pending, setPending] = useState(null);

  return (
    <div className="adm" data-testid="admin-dashboard">
      <header className="adm-head">
        <h1>Waitlist</h1>
        <span data-testid="admin-total-count">{data.total} signups</span>
        <a href={exportUrl} className="adm-btn" data-testid="admin-export-csv-button">Export CSV</a>
        <button className="adm-btn adm-btn-ghost" onClick={onLogout} data-testid="admin-logout-button">Log out</button>
      </header>
      <div className="adm-scroll">
        <table className="adm-table" data-testid="admin-signups-table">
          <thead>
            <tr><th>Email</th><th>Timestamp</th><th>Consent</th><th>Language</th><th>Consent version</th><th /></tr>
          </thead>
          <tbody>
            {data.items.map((s) => (
              <tr key={s.id} data-testid={`admin-row-${s.id}`}>
                <td>{s.email}</td>
                <td>{fmt(s.created_at)}</td>
                <td>{s.consent ? "yes" : "no"}</td>
                <td>{s.lang.toUpperCase()}</td>
                <td>{s.consent_version}</td>
                <td><button className="adm-del" onClick={() => setPending(s)} data-testid={`admin-delete-button-${s.id}`}>Delete</button></td>
              </tr>
            ))}
            {data.items.length === 0 && <tr><td colSpan={6} data-testid="admin-empty">No signups yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <AlertDialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
        <AlertDialogContent data-testid="admin-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete this signup?</AlertDialogTitle>
            <AlertDialogDescription>{pending?.email} will be removed permanently. This cannot be undone.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="admin-delete-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => onDelete(pending.id)} data-testid="admin-delete-confirm">Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
